<nb-card>
  <nb-card-body>
    <div id="print-section" class="print-layout">
      <div *ngIf="shop.coverUrl" class="logo-bill">
        <img width="100" [src]="shop.coverUrl" alt="" />
      </div>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td style="text-align: center">
            <h4>{{ shop.title }}</h4>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              {{ shop.address }}
            </label>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              ĐT: {{ shop.mobile }}
              <span *ngIf="shop.email"> - Email: {{ shop.email }} </span>
              <span *ngIf="shop.website"> - Web: {{ shop.website }} </span>
            </label>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>

        <tr>
          <td style="text-align: center">
            <h4>PHIẾU MUA HÀNG</h4>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              Ngày:
              {{ purchase.issueDate | date: "dd/MM/yyyy " }}
            </label>
          </td>
        </tr>
        <tr *ngIf="purchase.id.length > 6">
          <td style="text-align: center">
            <label>
              {{ "common.code" | translate }}:
              {{ purchase.id.substring(purchase.id.length - 6, 6) }}
            </label>
          </td>
        </tr>

        <tr>
          <td style="text-align: center">
            <table
              width="100%"
              style="border: 0px"
              cellpadding="0"
              cellspacing="0"
            >
              <tr>
                <td style="text-align: left; width: 60%">
                  <label>
                    <strong> Khách hàng: </strong> {{ purchase.supplierName }}
                  </label>
                </td>
                <td style="text-align: left; width: 40%">
                  <label>
                    <strong> ĐT: </strong> {{ purchase.supplierMobile }}
                  </label>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="text-align: left">
                  <strong> {{ "common.address" | translate }} : </strong>
                  {{ purchase.supplierAddress }}
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>
      </table>

      <table class="table-detail">
        <thead>
          <tr style="text-align: center">
            <th>
              <strong> {{ "common.no" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "product.code" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "product.name" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "product.unit" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "common.quantity" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "common.unitPrice" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "common.totalAmount" | translate }} </strong>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of purchase.purchaseDetails; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.productCode }}</td>
            <td style="text-align: left">
              <label>
                {{ item.productName }}
              </label>
            </td>
            <td style="text-align: left">
              <label>
                {{ item.productUnitName }}
              </label>
            </td>
            <td style="text-align: right">
              <label>
                {{ item.quantity | number: 0 }}
              </label>
            </td>
            <td style="text-align: right">
              <label>
                {{ item.price | number: 0 }}
              </label>
            </td>
            <td style="text-align: right">
              {{ item.netAmount | number: 0 }}
            </td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td colspan="6" style="text-align: right">
              <strong> {{ "common.netAmount" | translate }}: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ purchase.detailNetAmount | number: 0 }} </strong>
            </td>
          </tr>

          <tr>
            <td colspan="6" style="text-align: right">
              <strong>
                {{ "common.discount" | translate }}
                <span *ngIf="purchase.discountPercent > 0">
                  {{ purchase.discountPercent | number: 0 }}%
                </span>
                :
              </strong>
            </td>
            <td style="text-align: right">
              <strong>
                {{ purchase.totalDiscountAmount | number: 0 }}
              </strong>
            </td>
          </tr>

          <tr>
            <td colspan="6" style="text-align: right">
              <strong> {{ "common.totalAmount" | translate }}: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ purchase.totalAmount | number: 0 }} </strong>
            </td>
          </tr>
        </tfoot>
      </table>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td colspan="3" class="height-1"></td>
        </tr>

        <tr>
          <td style="text-align: center">
            <strong> Người lập phiếu </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>

          <td style="text-align: center">
            <strong> Người mua hàng </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>

          <td style="text-align: center">
            <strong> Người nhập kho </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>
        </tr>
      </table>
    </div>
  </nb-card-body>
</nb-card>
